
const colors = {
	givePrimary: '#ff5050',
	giveSecondary: '#008c8c',
	giveGrey200: 'rgb(247,247,246)',
	giveLightGrey: '#DDDDDD',
	giveMidGrey: '#999999',
	giveDarkGrey: '#666666',
	giveDarkerGrey: '#444444',
	giveBorderColor: 'rgba(0,0,0,0.1)',
	giveBorderColor1: 'rgba(0,0,0,0.2)',
	
};

module.exports = colors;
